module.exports = __webpack_public_path__ + "/img/DFN-4-2YL2VF.svg";